module.exports = __webpack_public_path__ + "img/ghs-icon.d0289dc0.png";